import { render, staticRenderFns } from "./dialogHandleSort.vue?vue&type=template&id=1ca6354f&scoped=true"
import script from "./dialogHandleSort.vue?vue&type=script&lang=js"
export * from "./dialogHandleSort.vue?vue&type=script&lang=js"
import style0 from "./dialogHandleSort.vue?vue&type=style&index=0&id=1ca6354f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6354f",
  null
  
)

export default component.exports